export const RSVP_STATUS = {
    NO: 0,
    YES: 1,
    MAYBE: 2
}